// extracted by mini-css-extract-plugin
export default {"list":"style_list__l8z1C","listTitle":"style_listTitle__qCjR8","listItems":"style_listItems__dYO+c","option":"style_option__ww3aL"};